module.exports = __webpack_public_path__ + "static/media/business-banner-img.a5545fba.png";